module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_c('em', [_vm._v("Author’s foreword")])])]), _vm._v(" "), _c('div', {
    staticClass: "lb-db"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_vm._v("GETTING STARTED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec1"
    }
  }, [_vm._v("Small but refined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec2"
    }
  }, [_vm._v("Types of small gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec3"
    }
  }, [_vm._v("Range of plants for small gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec4"
    }
  }, [_vm._v("Choice of infrastructure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec5"
    }
  }, [_vm._v("Problems and opportunities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec6"
    }
  }, [_vm._v("Design and planning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec7"
    }
  }, [_vm._v("Getting equipped")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec8"
    }
  }, [_vm._v("Lighting in a garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec9"
    }
  }, [_vm._v("Choosing and buying plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec10"
    }
  }, [_vm._v("Looking after plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec11"
    }
  }, [_vm._v("Flower gardens")])])]), _vm._v(" "), _c('div', {
    staticClass: "org-dorg"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHOOSING THE STYLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Informal gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Formal gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mediterranean influences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Japanese influences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Container gardening")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balcony and roof gardening")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creating a secluded garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Low-maintenance gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food-producing gardens")])])]), _vm._v(" "), _c('div', {
    staticClass: "gr-dgr"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PLANTS FOR SMALL GARDENS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer-flowering annuals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring-flowering bedding plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbaceous perennials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrubs and small trees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wall shrubs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rock-garden plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water and marginal plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bamboos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ornamental grasses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plants for containers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Small conifers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culinary herbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit: soft and top")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetables")])])]), _vm._v(" "), _c('div', {
    staticClass: "vio-dvio"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GARDEN CONSTRUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing a path")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Path construction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making a patio")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing a fence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choosing a wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garden steps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terraces and verandas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patios and courtyards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pergolas and trellises")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arches and arbors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Porches and entrances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edgings for borders and paths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sheds and summerhouses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greenhouses and cloches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 60
// module chunks = 0